export const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const formatFieldName = (str: string): string => {
  return str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^[a-z]|\s[a-z]/g, function (letter) {
    return letter.toUpperCase()
  })
}

export const formatText = (str: string, firstWordUppercase = false) => {
  // Changes 'redeemLink' to 'Redeem link'
  if (!str) return ''

  // Split the input string by capital letters
  const words = str.split(/(?=[A-Z])/)

  // Convert the first character of the first word to uppercase and the rest to lowercase
  words[0] = firstWordUppercase
    ? words[0].toUpperCase()
    : words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase()

  // Convert the remaining words to lowercase
  for (let i = 1; i < words.length; i++) {
    words[i] = words[i].toLowerCase()
  }

  // Join the words with spaces
  const result = words.join(' ')

  return result
}

export const copyToClipboard = (text: string): void => {
  navigator.clipboard.writeText(text)
}

interface IConcatenateNamesProps {
  firstName?: string | null
  lastName?: string | null
}

export const concatenateNames = ({ firstName, lastName }: IConcatenateNamesProps): string => {
  return `${firstName ?? ''} ${lastName ?? ''}`.trim()
}
